module.exports = "<div><mat-spinner></mat-spinner></div>\n"